import { Observable, of } from 'rxjs';
import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
  })
export class SignUpAuthGuard extends AuthGuard {
    authService = inject(AuthService);

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let isAuthenticated = false;
        this.authService.isAuthenticated$.subscribe(x => isAuthenticated = x);
        return of(!isAuthenticated);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.canActivate(childRoute, state).pipe(catchError(() => {
            this.authService.loginWithRedirect();
            return of(false);
        }));
    }

    log(){
        this.authService.isAuthenticated$.subscribe(x => console.log(x));
        this.authService.user$.subscribe(x => console.log(x));
    }
}
